/* Context value for guided walkthrough state. Split from provider for ESLint react-refresh. */

import { createContext } from "react";
import type { WalkthroughStep } from "@/data/guidedWalkthroughs";

export interface GuidedWalkthroughContextValue {
  isActive: boolean;
  start: (walkthroughId: string) => void;
  cancel: () => void;
  currentStep: WalkthroughStep | null;
  stepIndex: number;
  totalSteps: number;
  walkthroughName: string;
  targetRect: DOMRect | null;
  advance: () => void;
}

export const GuidedWalkthroughContext =
  createContext<GuidedWalkthroughContextValue | null>(null);
